<template>
  <div v-if="isAdmin" class="playground panel-admin-body">

      <lift-map :input-lift-map-data="liftTableData" />

      <br />
      <div v-if="isDeleteAramarkClientsUser" id="delete-aramark-clients" class="card d-none">
        <div class="card-header">Maintenance</div>
        <div class="card-body">
          <h5 class="card-title">Delete Aramark Clients</h5>
          <div class="form-group">
            <label>User ID</label>
            <input v-model="deleteUserId" type="number" class="form-control" placeholder="Enter your userId" />
          </div>
          <div class="form-group" style="margin-top:8px;">
            <label>Recipient Email</label>
            <input v-model="recipientEmail" type="email" class="form-control" placeholder="you@example.com" />
          </div>
          <div class="form-group" style="margin-top:8px;">
            <label>Client IDs (semicolon-separated)</label>
            <textarea v-model="clientIds" class="form-control" rows="3" placeholder="e.g., 101;102;103"></textarea>
          </div>
          <button class="btn btn-danger" style="margin-top:12px;" @click="onDeleteAramarkClients" :disabled="isSubmitting">
            {{ isSubmitting ? 'Starting...' : 'Delete Aramark Clients' }}
          </button>
        </div>
      </div>
  </div>

  <div v-else class="panel-admin-body no-permission-list">
    You do not have permission to view this page
  </div>
</template>

<script>
import ViewMixins from "../mixins/ViewMixins.vue";
import AdminMixins from "../mixins/AdminMixins.vue";
import DataTableMixins from "../mixins/DataTableMixins.vue";
import ContentMixins from "../mixins/ContentMixins.vue";
import ClientService from "../services/client.service";
import AdminService from "../services/admin.service";
import UserService from "../services/user.service";
import LiftMap from "./echarts/LiftMap.vue";

export default {
  name: "Playground",
  components: { LiftMap },
  mixins: [AdminMixins, ViewMixins, DataTableMixins, ContentMixins],
  data() {
    return {
      deleteUserId: null,
      liftTableData: { rows: [], summary: {} },
      recipientEmail: "",
      clientIds: "",
      isSubmitting: false
    };
  },
  computed: {
    isDeleteAramarkClientsUser() {
      return Number(UserService.getUserId()) === 1;
    }
  },
  methods: {
    async onDeleteAramarkClients() {
      if (!this.deleteUserId) {
        AdminService.displayErrorMessage({ text: "Please enter your userId" });
        return;
      }
      this.isSubmitting = true;
      await ClientService.deleteAramarkClients(this.deleteUserId, this.recipientEmail, this.clientIds, this.deleteAramarkClientsCallback, this);
      this.isSubmitting = false;
    },
    deleteAramarkClientsCallback(response) {
      let message = response.data && response.data.message ? response.data.message : "Deletion process has started. You will receive an email when it finishes.";
      AdminService.displaySuccessMessage({ text: message }, true);
    }
  }
};
</script>

<style scoped>
.card { margin-top: 16px; }
</style>
